<template>
  <div class="news-list">
    <ul>
      <li class="news-li" v-for="(item,index) in news">
        <router-link :to='"/details?id="+ item.id'>
          <div class="timeLabel">
            <span class="time">{{item.time}}</span>
            <span class="label">{{item.label}}</span>
          </div>
          <p class="title">{{item.title}}</p>
        </router-link>
      </li>
    </ul>
    <div class="waitnews" v-if="listlength==0">
      敬请期待
    </div>
  </div>
</template>

<script>
  export default{
    data() {
      return{
        num:'',
        page:'',
        start:0,
        end:'',
        listlength:''
      }
    },
    computed:{
      news(){
        let data=this.$store.state.languagesData.news.newslist;
        this.listlength=data.length;
        this.page=Math.round(this.listlength/this.$parent.num);
        return data.slice(this.start,this.end);
      }
    },
    methods:{
      adds(){
        this.start=this.num+this.start;
        this.end=this.start+this.num;
      },
      reductions(){
        this.start=this.start-this.num;
        this.end=Math.abs(this.start+this.num);
      }
    },
    mounted(){
      this.num=this.$parent.num;
      this.end=this.start+this.num;
    }
  }
</script>

<style scoped>
  .news-li{
    padding: 3% 2%;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
  }
  .timeLabel{
    font-size: 0;
    color: black;
  }
  .time{
    font-size: 14px;
    display: inline-block;
    vertical-align: middle;
  }
  .label{
    font-size: 16px;
    padding:0 5px;
    display: inline-block;
    vertical-align: middle;
    background-color: #536E7A;
    color: white;
    margin-left: 10px;
  }
  .title{
    font-size: 18px;
    margin-top: 5px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: black;
  }
  .waitnews{
    font-size: 20px;
    text-align: center;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/newsList.vue